var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 71,
    viewBox: "0 0 65 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1668 33.5758C54.1668 47.5841 39.8532 59.9659 34.4939 64.1109C33.3109 65.0259 31.6894 65.0259 30.5064 64.1109C25.1471 59.9659 10.8335 47.5841 10.8335 33.5758C10.8335 27.6989 13.1162 22.0626 17.1795 17.907C21.2428 13.7514 26.7538 11.4167 32.5002 11.4167C38.2465 11.4167 43.7575 13.7514 47.8208 17.907C51.8841 22.0626 54.1668 27.6989 54.1668 33.5758Z",
    stroke: "#00A944",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 41.2085C36.9873 41.2085 40.625 37.5708 40.625 33.0835C40.625 28.5962 36.9873 24.9585 32.5 24.9585C28.0127 24.9585 24.375 28.5962 24.375 33.0835C24.375 37.5708 28.0127 41.2085 32.5 41.2085Z",
    stroke: "#00A944",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2632_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 35.875C52.9914 35.875 59.875 28.9914 59.875 20.5C59.875 12.0086 52.9914 5.125 44.5 5.125C36.0086 5.125 29.125 12.0086 29.125 20.5C29.125 28.9914 36.0086 35.875 44.5 35.875Z",
    fill: "#EB5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.625 15.375L39.375 25.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.375 15.375L49.625 25.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2632_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoDenied);
export default __webpack_public_path__ + "static/media/geo-denied.72ed3dcfb410f0c921254142532feadf.svg";
export { ForwardRef as ReactComponent };